import type {ReactElement, RefObject} from 'react';
import {useEffect, useState} from 'react';
import React from 'react';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import styles from './template-filters-scroll-button.module.scss';
import throttle from 'lodash/throttle';

interface TemplateFiltersScrollButtonProps {
  containerRef: RefObject<HTMLUListElement | null>;
}

export function TemplateFiltersScrollButton({...props}: TemplateFiltersScrollButtonProps): ReactElement<any> {
  const [showLeftIcon, setShowLeftIcon] = useState(false);
  const [showRightIcon, setShowRightIcon] = useState(true);

  useEffect(() => {
    const handleScroll = throttle((): void => {
      if (!props.containerRef.current) {
        return;
      }

      if (props.containerRef.current.scrollLeft > 20) {
        setShowLeftIcon(true);
      } else {
        setShowLeftIcon(false);
      }

      const totalPossibleScroll = props.containerRef.current.scrollWidth - props.containerRef.current.clientWidth;
      if (props.containerRef.current.scrollLeft + 20 > totalPossibleScroll) {
        setShowRightIcon(false);
      } else {
        setShowRightIcon(true);
      }
    });

    const container = props.containerRef.current;
    if (container) container.addEventListener('scroll', handleScroll);

    return (): void => {
      if (container) container.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const onClickLeftIcon = (): void => {
    props.containerRef.current?.scrollTo({
      left: 0,
      behavior: 'smooth',
    });
  };

  const onClickRightIcon = (): void => {
    if (!props.containerRef.current) {
      return;
    }
    const totalPossibleScroll = props.containerRef.current.scrollWidth - props.containerRef.current.clientWidth + 1;

    props.containerRef.current?.scrollTo({
      left: totalPossibleScroll,
      behavior: 'smooth',
    });
  };

  const getLeftScrollIcon = (): ReactElement<any> | null => {
    return (
      <div className={`${styles.container} ${styles.left}`}>
        <Icon onClick={onClickLeftIcon} className={styles.icon} icon="icon-caret-left" type={IconType.SHADOW} shape={IconShape.CIRCLE} size={IconSize.SIZE_ICON_16} />
      </div>
    );
  };

  const getRightScrollIcon = (): ReactElement<any> | null => {
    return (
      <div className={`${styles.container} ${styles.right}`}>
        <Icon onClick={onClickRightIcon} className={styles.icon} icon="icon-caret-right" type={IconType.SECONDARY} shape={IconShape.CIRCLE} size={IconSize.SIZE_ICON_16} />
      </div>
    );
  };
  return (
    <>
      {showLeftIcon ? getLeftScrollIcon() : null}
      {showRightIcon ? getRightScrollIcon() : null}
    </>
  );
}
